var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 23.001C24.4773 23.001 20 27.7022 20 33.501C20 39.2998 24.4773 44.001 30 44.001C35.5227 44.001 40 39.2998 40 33.501C40 27.7022 35.5227 23.001 30 23.001ZM36.7896 30.5748L29.2587 38.4822C28.9998 38.7541 28.6468 38.9085 28.2801 38.9085C27.9133 38.9085 27.5603 38.7561 27.3014 38.4822L23.2104 34.1846C22.6711 33.6163 22.6711 32.6958 23.2104 32.1295C23.7517 31.5612 24.6264 31.5612 25.1696 32.1295L28.282 35.3975L34.8323 28.5176C35.3736 27.9493 36.2483 27.9493 36.7915 28.5176C37.3308 29.086 37.3308 30.0065 36.7915 30.5748H36.7896Z",
    fill: "#008577"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4558 10.001H10.5442C9.69072 10.001 9 10.6719 9 11.501C9 12.33 9.69072 13.001 10.5442 13.001H24.4558C25.3093 13.001 26 12.33 26 11.501C26 10.6719 25.3093 10.001 24.4558 10.001Z",
    fill: "#008577"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4558 16.001H10.5442C9.69072 16.001 9 16.6719 9 17.501C9 18.33 9.69072 19.001 10.5442 19.001H24.4558C25.3093 19.001 26 18.33 26 17.501C26 16.6719 25.3093 16.001 24.4558 16.001Z",
    fill: "#008577"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5178 22.001H10.4822C9.663 22.001 9 22.6719 9 23.501C9 24.33 9.663 25.001 10.4822 25.001H16.5178C17.337 25.001 18 24.33 18 23.501C18 22.6719 17.337 22.001 16.5178 22.001Z",
    fill: "#008577"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.184 0.000976562H3.41057C1.53546 0.000976562 0 1.53646 0 3.41159V35.5904C0 37.4655 1.53546 39.001 3.41057 39.001H18.1883C17.5171 37.5057 17.1232 35.8637 17.0548 34.1353H4.11197V5.12795H30.886V20.4747C32.331 20.5491 33.7138 20.8506 35 21.355V3.41159C35 1.53646 33.4645 0.000976562 31.5894 0.000976562H21.816",
    fill: "#008577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Icon);
export default __webpack_public_path__ + "static/media/step1-icon.ce66d7b776a1449884904f643a71cc01.svg";
export { ForwardRef as ReactComponent };